export default '<svg viewBox="0 0 98 84" >' +
  '<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">' +
  '<g id="fade-in" fill-rule="nonzero" data-fill="true">' +
  '<path d="M98,9.591 C98,4.646 94.005,0.653 89.062,0.653 L71.186,0.653 L2.301,69.536 C-0.767,72.605 -0.767,77.639 2.301,80.709 C5.787,84.227 ' +
  '11.447,84.227 14.964,80.709 L77.145,18.529 L89.062,18.529 C94.005,18.529 98,14.537 98,9.591 Z" id="Shape"></path>' +
  '</g></g></svg>';
